import React, { useEffect, useState } from "react";
import { Textfield } from './Textfield';
import Autocomplete from '@mui/material/Autocomplete';
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
export function Dropdown({ autoComplete, ...props }) {
  const [options, setOptions] = useState([]);
  const [selectedValue, setSelectedValue] = useState({});

  useEffect(() => {
    if (props.options?.length && autoComplete) {
      setOptions(props.options)
      let selectedValue = props.options.find(option => option.id == props.value)
      if (!selectedValue) selectedValue = props.options.find(option => option.name == props.value)
      setSelectedValue(selectedValue)
    }
  }, [props.options])

  const onChange = (event, newValue) => {
    if (autoComplete)
      event.target = {
        id: props.id,
        name: props.name,
        value: newValue || 0
      }
    props.onChange(event)
  }
  useEffect(() => {
    if (autoComplete && props.options?.length) {
      let selectedValue = props.options.find(option => option.id == props.value)
      if (!selectedValue) selectedValue = props.options.find(option => option.name == props.value)
      selectedValue ? setSelectedValue(selectedValue) : setSelectedValue(0)
    }
  }, [props.value])

  return (
    autoComplete ?
      <Autocomplete
        options={options}
        autoHighlight
        getOptionLabel={(option) => option.name || ""}
        value={selectedValue || null}
        onChange={onChange}
        id={props.id}
        name={props.name}
        disabled={props.disabled}
        disableClearable={props.disableClearable}
        renderInput={(params) => (
          <Textfield
            {...params}
            margin={props.margin}
            label={props.label}
            error={props.error}
            helperText={props.helperText}
            size={props.size}
          />
        )}
      /> :
      <FormControl fullWidth>
        <InputLabel>{props.label}</InputLabel>
        <Select
          id={props.id}
          name={props.name}
          value={props.value}
          label={props.label}
          onChange={onChange}
          size={props.size}
        >
          {
            props.options.map(option => {
              return <MenuItem key={option.id} value={option.id}>{option.name}</MenuItem>
            })
          }
        </Select>
      </FormControl>
  )
}